"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _ConfigProvider = require("../../providers/ConfigProvider");

var _canUseDOM = _interopRequireDefault(require("../../utils/canUseDOM"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Manager(_ref) {
  var onClose = _ref.onClose,
      visible = _ref.visible,
      children = _ref.children;
  (0, _utils.useReturnFocus)(!visible);

  var _useConfig = (0, _ConfigProvider.useConfig)(),
      createPortal = _useConfig.createPortal;

  var onKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'Escape') {
      onClose && onClose(event);
    }
  }, [onClose]); // Allow closing the modal by pressing the Escape key

  (0, _react.useEffect)(function () {
    if (visible && _canUseDOM.default) {
      document.addEventListener('keydown', onKeyDown);
      return function () {
        document.removeEventListener('keydown', onKeyDown);
      };
    } // eslint has issues with no return statement here...


    return undefined;
  }, [visible, onKeyDown]);

  if (visible) {
    return createPortal(children);
  }

  return null;
}

var _default = Manager;
exports.default = _default;